import Pages from './pages/Pages';
import Category from './components/Category';
import { BrowserRouter } from 'react-router-dom'; 
import Search from './components/Search'
import Header from './components/Header';
import banner from './components/Banner'
import Banner from './components/Banner';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
      <Banner />
        <Header />
        <Search />
        <Category /> 
        <Pages />
      </BrowserRouter>

    </div>
  );
}

export default App;
